// Part palette definitions, shared by the desktop drag palette (Sidebar.js) and
// the phone tap-to-add sheet (MobileWorkspace.js) so both stay in sync.
import pipeSvg from './components/svgs/pipe.svg';
import elbow90Svg from './components/svgs/90_opt.svg';
import elbow45Svg from './components/svgs/45_opt.svg';
import teeSvg from './components/svgs/tee.svg';
import chimneyTopStraightSvg from './components/svgs/pipe.svg';
import chimneyTopTeeSvg from './components/svgs/tee.svg';
import chimneyTop30Svg from './components/svgs/30_opt.svg';
import masonStraightSvg from './components/svgs/mason_straight_opt.svg';
import masonTeeSvg from './components/svgs/mason_tee_opt.svg';
import capSvg from './components/svgs/cap_opt.svg';

export const movableSections = [
  {
    title: 'Stove Pipes',
    components: [
      {
        label: 'Straight',
        svgSrc: pipeSvg,
        item: {
          name: 'Straight Pipe',
          type: 'Pipe',
          componentType: 'pipe-straight',
          diameters: ['6'],
          selectedDiameter: '6',
          orientation: 'vertical',
          wallType: 'Type A',
          surface: 'smooth',
          length: 1,
          height: 1,
          rotation: 0,
          rotationStep: 15,
        },
      },
      {
        label: 'Elbow 90°',
        svgSrc: elbow90Svg,
        item: {
          name: 'Elbow 90°',
          type: 'Elbow',
          componentType: 'elbow-90',
          diameters: ['6'],
          selectedDiameter: '6',
          orientation: 'vertical',
          wallType: 'Type A',
          surface: 'smooth',
          height: 1,
          rotation: 0,
          rotationStep: 90,
        },
      },
      {
        label: 'Elbow 45°',
        svgSrc: elbow45Svg,
        item: {
          name: 'Elbow 45°',
          type: 'Elbow',
          componentType: 'elbow-45',
          diameters: ['6'],
          selectedDiameter: '6',
          orientation: 'vertical',
          wallType: 'Type A',
          surface: 'smooth',
          height: 1,
          rotation: 0,
          rotationStep: 45,
          angleLabel: '45°',
        },
      },
      {
        label: 'Tee',
        svgSrc: teeSvg,
        item: {
          name: 'Tee',
          type: 'Elbow',
          componentType: 'tee',
          diameters: ['6'],
          selectedDiameter: '6',
          orientation: 'vertical',
          wallType: 'Type A',
          surface: 'smooth',
          height: 1,
          rotation: 0,
          rotationStep: 90,
        },
      },
    ],
  },
  {
    title: 'Chimneys',
    components: [
      {
        label: 'Straight',
        svgSrc: chimneyTopStraightSvg,
        item: {
          name: 'Chimney Straight',
          type: 'Pipe',
          componentType: 'chimney-straight',
          diameters: ['6'],
          selectedDiameter: '6',
          orientation: 'vertical',
          wallType: 'Type A',
          surface: 'smooth',
          length: 1,
          height: 1,
          rotation: 0,
          rotationStep: 15,
        },
      },
      {
        label: 'Tee',
        svgSrc: chimneyTopTeeSvg,
        item: {
          name: 'Chimney Tee',
          type: 'Elbow',
          componentType: 'chimney-tee',
          diameters: ['6'],
          selectedDiameter: '6',
          orientation: 'vertical',
          wallType: 'Type A',
          surface: 'smooth',
          height: 1,
          rotation: 0,
          rotationStep: 90,
        },
      },
      {
        label: 'Elbow 30°',
        svgSrc: chimneyTop30Svg,
        item: {
          name: 'Chimney 30°',
          type: 'Elbow',
          componentType: 'chimney-30',
          diameters: ['6'],
          selectedDiameter: '6',
          orientation: 'vertical',
          wallType: 'Type A',
          surface: 'smooth',
          height: 1,
          rotation: 0,
          rotationStep: 30,
          angleLabel: '30°',
        },
      },
    ],
  },
  {
    title: 'Lined Masonry Chimneys',
    components: [
      {
        label: 'Straight',
        svgSrc: masonStraightSvg,
        item: {
          name: 'Masonry Straight',
          type: 'Pipe',
          componentType: 'masonry-straight',
          diameters: ['6'],
          selectedDiameter: '6',
          orientation: 'vertical',
          wallType: 'Type A',
          surface: 'smooth',
          length: 1,
          height: 1,
          rotation: 0,
          rotationStep: 15,
        },
      },
      {
        label: 'Tee',
        svgSrc: masonTeeSvg,
        item: {
          name: 'Masonry Tee',
          type: 'Elbow',
          componentType: 'masonry-tee',
          diameters: ['6'],
          selectedDiameter: '6',
          orientation: 'vertical',
          wallType: 'Type A',
          surface: 'smooth',
          height: 1,
          rotation: 0,
          rotationStep: 90,
        },
      },
    ],
  },
  {
    title: 'Termination',
    components: [
      {
        label: 'Cap',
        svgSrc: capSvg,
        item: {
          name: 'Cap',
          type: 'Elbow',
          componentType: 'cap',
          diameters: ['6'],
          selectedDiameter: '6',
          wallType: 'Type A',
          surface: 'smooth',
          height: 1,
          rotation: 0,
          rotationStep: 90,
        },
      },
    ],
  },
];
